'use client';

import LinkDetailBlocksPreview from './components/LinkDetailBlocksPreview';
import { ILink } from 'core/types/Models/linkType';
import EmptyLinkDetail from 'components/LinkDetail/components/Empty/EmptyLinkDetail';
import { useEffect } from 'react';
import { setTemplateDetail } from 'core/store/slice/template/templateSlice';
import { useDispatch } from 'react-redux';

const LinkDetail = ({ linkDetailData }: { linkDetailData: ILink | undefined }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    linkDetailData?.template && dispatch(setTemplateDetail(linkDetailData?.template));
  }, []);

  return <>{linkDetailData?.blocks?.length === 0 ? <EmptyLinkDetail /> : <LinkDetailBlocksPreview link={linkDetailData} />}</>;
};

export default LinkDetail;
